import { render, staticRenderFns } from "./le-price-detail.vue?vue&type=template&id=9ad11c1a&scoped=true&"
import script from "./le-price-detail.vue?vue&type=script&lang=js&"
export * from "./le-price-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad11c1a",
  null
  
)

export default component.exports